<app-header-logistic-import></app-header-logistic-import>
<div class="conatiner-content-logistic-import">
    <div class="breadcrumb">
        <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
    </div>
    <div class="logistic-import-container">
        <app-content-logistic-import></app-content-logistic-import>
    </div>
</div>
